import createAxiosInstance from '../../../../api';
import { useAlert } from '../../../../components/Notification';
import { useDispatch } from 'react-redux';
import {
  setAllControllerListAction,
  setGetControllerDetails,
  setGetControllerFilters,
  setControllerListAction,
} from '../../../../stores/actionTypes/controllerActions';
import { useNavigate } from 'react-router-dom';

export function useHook() {
  const axiosInstance = createAxiosInstance();
  const navigate = useNavigate();
  const showAlert = useAlert();
  const dispatch = useDispatch();

  const fetchAllControllerList = async (payload) => {
    await axiosInstance
      .post('/listController', payload)
      .then((response) => {
        dispatch(setAllControllerListAction(response?.data?.data));
      })
      .catch(() => {
        dispatch(setAllControllerListAction([]));
        showAlert('Failed get All List Controller', 'warning');
      });
  };

  const fetchControllerList = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/listController', payload)
      .then((response) => {
        dispatch(setControllerListAction(response?.data?.data));
        data = response.data;
      })
      .catch(() => {
        dispatch(setControllerListAction([]));
        showAlert('Failed get List Controller', 'warning');
      });
    return data;
  };

  const fetchGetControllerDetails = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/getController', payload)
      .then((response) => {
        dispatch(setGetControllerDetails(response?.data?.data));
        data = response;
      })
      .catch(() => {
        dispatch(setGetControllerDetails({}));
        showAlert('Failed get List Controller', 'warning');
      });
    return data;
  };

  const createController = async (payload) => {
    // let data = null;
    await axiosInstance
      .post('/createController', payload)
      .then((response) => {
        if (response?.data?.success) {
          showAlert('Controller created successfully', 'success');
          navigate('/hardware/controller');
        }
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    // return data;
  };

  const fetchGetControllerFilter = async () => {
    await axiosInstance
      .get('/controllerFilters')
      .then((response) => {
        dispatch(setGetControllerFilters(response?.data?.data));
      })
      .catch(() => {
        dispatch(setGetControllerFilters([]));
        showAlert('Failed get  Controller Filter', 'warning');
      });
  };

  const deleteController = async (payload) => {
    await axiosInstance
      .post('/deleteController', payload)
      .then(() => {
        showAlert('Controller deleted successfully', 'success');
      })
      .catch(() => {
        showAlert('Failed to delete  Controller', 'warning');
      });
  };

  const editController = async (payload) => {
    await axiosInstance
      .post('/updateController', payload)
      .then((response) => {
        if (response?.data?.success) {
          showAlert('Controller Update Successful', 'success');
        }
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
  };

  return {
    fetchAllControllerList,
    fetchControllerList,
    fetchGetControllerDetails,
    fetchGetControllerFilter,
    deleteController,
    editController,
    createController,
  };
}
